import { memo, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputLabel,
  Typography,
} from '@mui/material';
import { CloseIcon } from '~/assets/icons';
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from '~/redux/hooks';
import { BaseSelect } from '~/components/common';
import { IEstimateTemplate } from '~/utils/interface/estimate-template';
import { handleGetEstimateTemplates } from '~/thunks/estimate-template/estimateTemplateThunk';
import { handleApiError } from '~/utils/helper';

type EstimateListProps = {
  open: boolean;
  setOpen?: (open: boolean, needRefreshData?: boolean) => void;
  setTemplateId: (templateId: Array<number>) => void;
};

function CreateFromTemplateDialog(props: EstimateListProps) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['admin/job']);
  const [templateOptions, setTemplateOptions] = useState<Array<IEstimateTemplate>>([]);
  const [templateId, setTemplateId] = useState<Array<number>>([]);
  const [errorText, setErrorText] = useState<string>('');

  useEffect(() => {
    const handleGetList = async () => {
      try {
        const response = await dispatch(handleGetEstimateTemplates({ data: { limit: 0 } })).unwrap();
        setTemplateOptions(response.responses);
      } catch (e) {
        handleApiError(e);
      }
    };
    props.open && handleGetList();
  }, [dispatch, props.open]);

  const handleSetOpen = (open: boolean) => {
    setTemplateId([]);
    setErrorText('');
    props.setOpen && props.setOpen(open);
  };

  const handleSubmit = () => {
    if (templateId) {
      props.setTemplateId(templateId);
      setTemplateId([]);
    } else {
      setErrorText(t('estimateTemplate.required'));
    }
  };
  const handleCancel = () => {
    handleSetOpen(false);
  };
  return (
    <Dialog open={props.open} onClose={() => handleSetOpen(false)} fullWidth maxWidth='md'>
      <DialogTitle>
        {t('estimateTemplate.selectEstimateTemplate')}
        <IconButton onClick={() => handleSetOpen(false)} className='absolute right-[10px] top-[10px]'>
          <CloseIcon className='w-[10px] h-[10px]' />
        </IconButton>
      </DialogTitle>

      <DialogContent className='p-0'>
        <Box className='mt-3 w-full'>
          <InputLabel className='content-center	'> {t('estimateTemplate.availableTemplates')}</InputLabel>
          <BaseSelect
            name={`templateId`}
            className='w-full'
            value={templateId}
            options={templateOptions}
            required={true}
            onChange={(event) => setTemplateId(event.target.value)}
            multiple
          ></BaseSelect>
          <Typography className='text-red-600 text-[12px]'>{errorText}</Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button color='secondary' variant='contained' onClick={() => handleCancel()}>
          {t('cancel', { ns: 'admin/common' })}
        </Button>
        <Button color='primary' variant='contained' onClick={() => handleSubmit()}>
          {t('save', { ns: 'admin/common' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default memo(CreateFromTemplateDialog);
